import type { DigestHighlightItem } from '../types';

export function filterInvalidDigestLinks(items: DigestHighlightItem[]) {
  return items.filter(item => {
    const isValidLink =
      typeof item.digestLink === 'string' && item.digestLink.trim() !== '';
    const isValidText =
      typeof item.digestLinkText === 'string' &&
      item.digestLinkText.trim() !== '';

    return isValidLink && isValidText;
  });
}
